import React, { useState } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import routePathSegments, { routeNames } from '../../../routeSegments'
import useModule from '../../../hooks/useModule'
import InvestorCo_Investors from './InvestorCo_Investors'
import PopupHandler from '../../AISummaryPopup'

/**
 * The CoInvestorLayOut function renders a component that displays co-investors and provides a link to
 * view all co-investors.
 * @returns The CoInvestorLayOut component is returning JSX elements.
 */
const CoInvestorLayOut = (props) => {
    const { investorId } = useParams()
    const { primaryMasterId } = useModule()
    const [showAIPopup, setShowAIPopup] = useState(false);

    return (
        <div className="px-4 bg-[#EDEDED] w-[100%]">
            <div className=" mt-4 bg-white border  overflow-hidden sm:rounded-lg">
                <div className="pt-4">
                    <div className="flex flex-col justify-between mb-3">
                        <div className='flex items-center gap-3'>
                            <h3 className="pl-6 pr-0 mb-2 text-[14pt] leading-[19pt] text-[#333333] lg:text-[18px] lg:leading-[22px] font-semibold">Co-investors</h3>
                            <NavLink 
                                className="relative px-[0.25rem] text-xs lg:text-[13px] font-semibold border border-[#0077B7] bg-[#0077B7] rounded-sm text-white cursor-pointer mb-2"
                                to={routeNames.coInvestorAiSummary(investorId)}
                                target='_blank'
                            >
                                <span className="text-xs text-red-700 absolute -top-3 -right-7">Beta</span>
                                Summary
                            </NavLink>
                        </div>
                        <InvestorCo_Investors investorId={investorId} primaryMasterId={primaryMasterId} page="investor"/>
                        {/* <NavLink to={`/${primaryMasterId == 1 ? 'pe' : 'vc' }/co-investors`} state={{investorId:investorId,typeId:primaryMasterId}} className="font-sans_medium_body text-base text-[#A3751F] text-[13.5px] font-bold px-2">View All</NavLink> */}
                        <div className='flex justify-center items-center'>
                            <NavLink target='_blank' to={primaryMasterId == 1 ? routeNames.peCoInvestorById(investorId): routeNames.vcCoInvestorById(investorId)} state={{investorId:investorId,typeId:primaryMasterId}} className=" ml-8 mt-2 text-right cursor-pointer bg-[#BC8B20] text-white rounded px-4 py-1">View More</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CoInvestorLayOut
